interface BookableSessionShape {
    IsActive?: boolean | null;
    MeetingType?: string | null;
}

/**
 * A professional's linked Client Director session is only bookable when it is
 * active and one-on-one — the same rule the project detail page uses. The
 * page offers it to the Book a meeting button when nothing else names one.
 */
export const isBookableSession = (
    session?: BookableSessionShape | null,
): boolean =>
    Boolean(session?.IsActive && session.MeetingType === 'one-on-one');
